import { ApplicationConfig, inject, provideEnvironmentInitializer, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideStoreDevtools } from '@ngrx/store-devtools';
import { connectFirestoreEmulator, getFirestore, provideFirestore } from '@angular/fire/firestore'
import { connectStorageEmulator, getStorage, provideStorage } from '@angular/fire/storage';
import { connectAuthEmulator, getAuth, provideAuth } from '@angular/fire/auth';
import { getAnalytics, provideAnalytics } from "@angular/fire/analytics";
import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { withInterceptors } from '@angular/common/http';

import { routes } from './app.routes';
import { provideState, provideStore } from '@ngrx/store';
import { authUserFeature } from './store/authUser.store';
import { environment } from '../environments/environment';
import { Logger } from './helper/logger';
const log = new Logger('app.config');

import { provideDataConnect } from '@angular/fire/data-connect';
import { getDataConnect, connectDataConnectEmulator, DataConnect } from 'firebase/data-connect';
log.log('+*+ config hit!');
import { connectorConfig } from '@dataconnect/account'


if (!connectorConfig) {
        throw new Error('CRITICAL: connectorConfig is undefined or null!');
      }
const app =  initializeApp(environment.firebase);
export const firestore = getFirestore(app);
import { accountFeature } from './store/account.store';
import { connectFunctionsEmulator, provideFunctions } from '@angular/fire/functions';
import { getFunctions } from '@angular/fire/functions'; //'firebase/functions';
import { listingsFeature } from './store/listings.store';
import { categoriesFeature } from './store/category.store';
import { alertFeature } from './store/alert.store';
import { provideAnimations } from '@angular/platform-browser/animations';
import { ordersFeature } from './store/order.store';
import { interactionsFeature } from './store/interactions.store';
import { searchFeature } from './store/search.store';
import { provideHttpClient } from '@angular/common/http';
import { authInterceptor } from './app.guard';
export const appConfig: ApplicationConfig = {
  providers: [provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideStore(),
    provideAnimations(),
    provideState(authUserFeature),
    provideState(accountFeature),
    provideState(listingsFeature),
    provideState(categoriesFeature),
    provideState(ordersFeature),
    provideState(alertFeature),
    provideState(interactionsFeature),
    provideState(searchFeature),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideFirebaseApp(() => {
      log.log('+*+ provideFirebaseApp hit!');
      try {
        log.log('Firebase App initialized successfully:  App Name:', app.name);
        return app;
      } catch (error) {
        log.error('ERROR during Firebase App initialization:', error);
        throw error; // Re-throw to propagate the error
      }
    }), // Initialize the main app here
    provideDataConnect(() => {
      log.log('+*+ provideDataConnect hit!');
      const dc = getDataConnect(connectorConfig);
      if (environment.useEmulator) { // Use environment.useEmulator for debug builds
        log.log({msg:'should be on local now!!!'})
        connectDataConnectEmulator(dc, 'localhost', 9399);
      }
      return dc;
    }),
    provideAuth(() => {
      log.log('+*+ provideAuth hit!');
      const auth = getAuth();
      if (environment.useEmulator) { // Use environment.useEmulator for debug builds
        connectAuthEmulator(auth, 'http://127.0.0.1:9099',{ disableWarnings: true }); // Connect *this* auth instance to emulator
        log.log('App.config.ts Auth Emulator Config:', auth.emulatorConfig); // <--- LOG THIS
      }
      return auth;
    }),
    provideFirestore(() => {
      log.log('+*+ provideFirestore hit!');
      if (environment.useEmulator) { // Use environment.useEmulator for debug builds
        connectFirestoreEmulator(firestore, '127.0.0.1', 8080); // Connect *this* firestore instance to emulator (note common port 8080)
      }
      return firestore;
    }),
    provideFunctions(() => {
      log.log('+*+ provideFunctions hit!');
      const functions = getFunctions();
      if (environment.useEmulator) { // Use environment.useEmulator for debug builds
        connectFunctionsEmulator(functions, 'localhost', 5001);
      }
      return functions;
    }),
    provideAnalytics(() => getAnalytics()), // Initialize Analytics if needed
    provideStorage(() => {
      log.log('+*+ provideStorage hit!');
      const storage = getStorage();
      if (environment.useEmulator) { // Use environment.useEmulator for debug builds
        connectStorageEmulator(storage, '127.0.0.1', 9199); // Connect *this* storage instance to emulator
      }
      return storage;
    }),
    provideStoreDevtools({ maxAge: 25, logOnly: environment.production }),
    provideEnvironmentInitializer(() => {
      if (environment.useEmulator) {
        log.log('App is running in development mode with emulator settings.');
        inject(DataConnect); // this is needed to trigger the provider and emulator connection on app load, otherwise the first call to data connect will trigger the provider and emulator connection which can cause a  race condition if it happens after a call to data connect but before the provider and emulator connection in the provider, which can cause the app to try to connect to the production data connect instead of the emulator.
      }
    })
  ]
};

